export const TITLE_TRANSLATION = 'TITLE_TRANSLATION';
export const TITLE_TRANSLATION_ID = 'TITLE_TRANSLATION_ID';
export const QUESTIONS = 'QUESTIONS';
export const QUIZZES = 'QUIZZES';
export const QUIZ = 'QUIZ';



// WEBPACK FOOTER //
// ./src/store/modules/quiz/mutation-types.js